<template>
  <div class="ui left aligned container">
    <vuetable ref="vuetable"
              api-url="/zhihu/clubs"
              :fields="fields"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    <div>
      <br/>
      <a href="https://www.zhihu.com/club/1155432463122796544" target="_blank">知乎圈子</a>
    </div>
    <div class="ui hidden divider"></div>
    <div class="row">
      <date-picker range valueType="format" @clear="range=[]" v-model="range"></date-picker>
      <button class="ui load button" @click="load">Load</button>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
.ui.load.button {
  margin-left: 12px;
}
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'ZhihuClub',
    components: {
      Vuetable,
      VuetablePagination,
      DatePicker,
      'v-chart': ECharts
    },
    data () {
      return {
        fields: [
          {name: 'date', title: '日期'},
          {name: 'joinCount', title: '成员'},
          {name: 'postCount', title: '帖子'},
        ],
        page: 0,
        range: [],
        options: null,
        sortOrder: [
          {
            field: 'date',
            direction: 'desc'
          }
        ]
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        if (page === 'prev') {
          this.page--
        } else if (page === 'next') {
          this.page++
        } else {
          this.page = parseInt(page)
        }
        this.range = [];
        this.load();
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        let api = `/zhihu/clubs/chart?size=10&page=${this.page}`
        if (this.range.length === 2) {
          api = `/zhihu/clubs/chart?start=${this.range[0]}&end=${this.range[1]}`
        }
        axios.get(api).then(response => {
          this.options =
            {
              title: {
                text: '增幅'
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['帖子', '成员']
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: '帖子',
                  type: 'line',
                  data: response.data.map(e => [e.date, e.postCount])
                },
                {
                  name: '成员',
                  type: 'line',
                  data: response.data.map(e => [e.date, e.joinCount])
                },
              ]
            };
        });
      }
    }
  }
</script>
